import { useCallback, useMemo } from "react";
import { useDropzone } from "react-dropzone";

const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "0px",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#eeeeee",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out",
};

const activeStyle = {
  borderColor: "#2196f3",
};

const acceptStyle = {
  borderColor: "#00e676",
};

const rejectStyle = {
  borderColor: "#ff1744",
};

const DropZone = ({ setSelectedFiles }) => {
  // const onDrop = useCallback((acceptedFiles) => {
  //   console.log('Accepted a file - now do something with it')
  //   let files = []
  //   acceptedFiles.forEach((file, index) => {
  //     if (file.size <= (500 * 1024 * 1024)) { // file size <= 500MB
  //       const reader = new FileReader()

  //       reader.onabort = () => console.log('file reading was aborted')
  //       reader.onerror = () => console.log('file reading has failed')
  //       reader.onload = () => {
  //         // Do whatever you want with the file contents
  //         // const binaryStr = reader.result
  //         // console.log(binaryStr)
  //         files.push(file)

  //         // Check if all files have been read
  //         if (index === acceptedFiles.length - 1) {
  //           setSelectedFile(files)
  //         }
  //       }
  //       reader.readAsArrayBuffer(file)
  //     } else {
  //       alert('File is too large');
  //     }
  //   })

  // }, [setSelectedFile])

  const onDrop = useCallback(
    acceptedFiles => {
      const validFiles = acceptedFiles.filter(
        file => file.size <= 500 * 1024 * 1024,
      ); // file size <= 500MB

      if (validFiles.length !== acceptedFiles.length) {
        alert("Some files are too large and have been excluded.");
      }

      validFiles.forEach(file => {
        const reader = new FileReader();

        reader.onabort = () => console.log("file reading was aborted");
        reader.onerror = () => console.log("file reading has failed");
        reader.onload = () => {
          // Do whatever you want with the file contents
          // const binaryStr = reader.result
          // console.log(binaryStr)
        };
        reader.readAsArrayBuffer(file);
      });

      setSelectedFiles(validFiles);
    },
    [setSelectedFiles],
  );

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
    acceptedFiles,
  } = useDropzone({ onDrop, multiple: true });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...{ cursor: "pointer" },
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept],
  );

  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0 || !bytes) return null;

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  const files = acceptedFiles.map(file => (
    <li key={file.path}>
      {file.path} - {formatBytes(file.size)}
    </li>
  ));

  return (
    <div className="container">
      <div {...getRootProps({ style })}>
        <input {...getInputProps()} />
        <p>Drag and drop a file here or click to select a file</p>
      </div>
      {files.length > 0 && (
        <aside>
          <h4>File</h4>
          <ul>{files}</ul>
        </aside>
      )}
    </div>
  );
};

export default DropZone;
